import { ArrowLeft, Bookmark, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useToast } from "@/hooks/use-toast";

interface MobileChatHeaderProps {
  title: string;
  onBack: () => void;
  bookmarked?: boolean;
  onToggleBookmark?: () => void;
  shareUrl?: string;
}

const MobileChatHeader = ({ title, onBack, bookmarked, onToggleBookmark, shareUrl }: MobileChatHeaderProps) => {
  const { toast } = useToast();

  const handleShare = async () => {
    const url = shareUrl || window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        /* user cancelled */
      }
    } else {
      await navigator.clipboard.writeText(url);
      toast({ title: "Link copied", description: "Chat link copied to clipboard" });
    }
  };

  return (
    <header className="flex h-14 items-center gap-1 border-b border-border bg-card px-2 shrink-0 md:hidden">
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 shrink-0"
        onClick={onBack}
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <span className="text-sm font-semibold text-foreground truncate flex-1">
        {title}
      </span>
      {onToggleBookmark && (
        <Button variant="ghost" size="icon" className="h-9 w-9 shrink-0" onClick={onToggleBookmark}>
          <Bookmark className={cn("h-5 w-5", bookmarked ? "fill-primary text-primary" : "text-muted-foreground")} />
        </Button>
      )}
      <Button variant="ghost" size="icon" className="h-9 w-9 shrink-0" onClick={handleShare}>
        <Share2 className="h-5 w-5 text-muted-foreground" />
      </Button>
    </header>
  );
};

export default MobileChatHeader;
